"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NegativeUnreadCountException = void 0;
class NegativeUnreadCountException extends Error {
    constructor(e) {
        // If e is an object with message/details, use them
        if (e && typeof e === "object" && e.message) {
            super(e.message);
            this.details = e;
        }
        else {
            super(e);
        }
        this.stack = (e === null || e === void 0 ? void 0 : e.stack) || this.stack;
        this.name = "NegativeUnreadCountException";
        this.code = "NEGATIVE_UNREAD_COUNT_ERROR";
    }
}
exports.NegativeUnreadCountException = NegativeUnreadCountException;
